import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';

import { ContactApiService } from '../index';
import { CheckContractorLicense,    CheckLDPLicense,    CONTACT_LDP_UNLISTED_MUTATION,    ContactExistsQuery,   GetLdpByIdQuery,   IContact,  IContactExists,  IContactInput } from '@ebb-v2/ebb-integration';

import { Apollo } from 'apollo-angular';
import {
  ListContactsQuery,
  GetContactByIdQuery,
  CONTACT_MUTATION, CONTACT_CONTRACTOR_UNLISTED_MUTATION
} from '@ebb-v2/ebb-integration';
import { contactLdpExistsDetail } from 'libs/ebb-integration/src/lib/graphql/queries/contact.query';

@Injectable({
  providedIn: 'root'
})
export class ContactGqlService implements ContactApiService {
  currentUser: Observable<IContact>;

  constructor(private apollo: Apollo) {}

  public getContact(id: string, resetCache:boolean): Observable<IContact> {
    //console.log(`ContactGql.getContact()`);
    return this.apollo
      .query({
        query: GetContactByIdQuery,
        variables: {
          id: id,
          resetCache: resetCache
        },
        fetchPolicy: 'network-only'
      })
      .pipe( map(result => result.data['contact'] as IContact), take(1) );
  }

  public getContacts(): Observable<IContact[]> {
    //console.log(`ContactGql.getContacts()`);
    return this.apollo
      .watchQuery({
        query: ListContactsQuery
      })
      .valueChanges.pipe(
        map(result => result.data['contacts'] as IContact[]),
        take(1)
      );
  }

  public updateContact(contact: IContactInput): Observable<IContact> {
    //console.log(`ContactGql.saveContact()`);
    return this.apollo
      .mutate({
        mutation: CONTACT_MUTATION,
        variables: {
          contact
        }
      })
      .pipe(map(result => result.data['saveContact'] as IContact));
  }
  public CheckLdpContactExists(email: string) : Observable<IContactExists>{
    return this.apollo.query({
        query: contactLdpExistsDetail,
        fetchPolicy: 'network-only',
        variables: { email: email}
      })
      .pipe(map(result => {
        if(result.data['message']) {
          return result.data['message'];
        }
        return result.data['contactLdpExistsDetail'] as IContactExists;
      }
    ));
}
  public saveContactUnlisted(contact: IContactInput): Observable<IContact> {
    //console.log(`ContactGql.saveContactUnlisted()`);
    return this.apollo
      .mutate({
        mutation: CONTACT_CONTRACTOR_UNLISTED_MUTATION,
        variables: {
          contact
        }
      })
      .pipe(map(result => result.data['saveContractorUnlisted'] as IContact));
  }
  public saveLdpUnlisted(contact: IContactInput): Observable<IContact> {
    //console.log(`ContactGql.saveLdpUnlisted()`);
    return this.apollo
      .mutate({
        mutation: CONTACT_LDP_UNLISTED_MUTATION,
        variables: {
          contact
        }
      })
      .pipe(map(result => result.data['saveLdpUnlisted'] as IContact));
  }
  public checkContractorLicense(licenseNumber: string): Observable<IContact> {
    console.log(`ContactGql.checkContractorLicense()`);
    return this.apollo
      .watchQuery({
        query: CheckContractorLicense,
        variables: {
          licenseNumber: licenseNumber
        }
      })
      .valueChanges.pipe(
        map(result => result.data['checkContractorLicense'] as IContact),
        take(1)
      );
  }

  public CheckLDPLicense(licenseNumber: string): Observable<IContact> {
    console.log(`ContactGql.checkLdpLicense()`);
    return this.apollo
      .watchQuery({
        query: CheckLDPLicense,
        variables: {
          licenseNumber: licenseNumber
        }
      })
      .valueChanges.pipe(
        map(result => result.data['checkLdpLicense'] as IContact),
        take(1)
      );
  }
  public getContactExists(email : string): Observable<boolean> {
    console.log(`ContactGql.ContactExistsQuery()`);
    return this.apollo
      .watchQuery({
        query: ContactExistsQuery,
        variables: {
          email
        }
      })
      .valueChanges.pipe(
        map(result => result.data['contactExists'] as boolean),
        take(1)
      );
  }
  public GetLdpByIdQuery(
    id: string,
    resetCache: boolean
  ): Observable<IContact> {
    //console.log(`ContractorGql.getContractor()`);
    return this.apollo
      .watchQuery({
        query: GetLdpByIdQuery,
        variables: {
          id: id,
          resetCache: resetCache
        }
      })
      .valueChanges.pipe(
        map(result => result.data['getldpcontact'] as IContact),
        take(1)
      );
  }
}
